/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import wizardStyle from "../../wizardStyle";
import Grid from "@mui/material/Grid";
import MenuItem from "@mui/material/MenuItem";
import { dateFieldDefault, pastDateDefault, requiredValidator } from "../../../../services/validationRules";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import Person from "../../Common/Person/Person";
import Address from "../../Common/Address/Address";
import { useForm } from "../../../../provider/Form/FormProvider";
import ValidatorTextField from "../../../FormFields/ValidatorTextField";
import ValidatorSelectField from "../../../FormFields/ValidatorSelectField";
import _get from "lodash/get";
import { formValue } from "../../../../services/formServiceFunctions";
import FormLegend from "../../Common/FormLegend/FormLegend";
import NumberFieldConfigured from "../../ConfiguredFormElements/NumberFieldConfigured/NumberFieldConfigured";
import { AbstractCase } from "../../../../types/Entities/AbstractCase";

type AlimonyPersonProps = {
  path: string;
  index: number;
  product: AbstractCase;
};

export default function AlimonyPerson({ path, index, product }: AlimonyPersonProps) {
  const { values, handleChange } = useForm();
  return (
    <>
      <Person path={path} headline={`Wie heißt die ${index + 1}. Person, der Sie Unterhalt zahlen bzw. die bei Ihnen wohnt?`} />
      <Grid item xs={12} sx={wizardStyle.gridTopSpaced}>
        <FormLegend>Wo wohnt die Person?</FormLegend>
      </Grid>
      <Grid item xs={12}>
        <FormControlLabel
          control={
            <Checkbox
              name={path + ".livesWithPetitioner"}
              checked={_get(values, path + ".livesWithPetitioner")}
              onChange={handleChange}
              value="livesWithPetitioner"
              color="primary"
            />
          }
          label="Wohnt bei mir"
        />
      </Grid>
      {!_get(values, path + ".livesWithPetitioner") && <Address path={path + ".address"} headline="" />}
      <Grid item xs={12} sx={wizardStyle.gridTopSpaced}>
        <FormLegend>Wann wurde die Person geboren?</FormLegend>
      </Grid>
      <Grid item xs={12}>
        <ValidatorTextField
          name={path + ".birthDate"}
          label="Geburtsdatum"
          validators={[requiredValidator("Bitte geben Sie das Datum an"), dateFieldDefault, pastDateDefault]}
        />
      </Grid>
      <Grid item xs={12} sx={wizardStyle.gridTopSpaced}>
        <FormLegend>Welches Verhältnis haben Sie zu der Person?</FormLegend>
      </Grid>
      <Grid item xs={12}>
        <ValidatorSelectField
          label={"Verhältnis"}
          name={path + ".relation"}
          validators={[requiredValidator("Bitte geben Sie das Verhältnis an")]}
          MenuProps={{ PaperProps: { style: { maxHeight: 200 } } }}
        >
          <MenuItem value={"Kind"}>Sie ist mein Kind</MenuItem>
          <MenuItem value={"Ehepartner"}>Sie ist mein Ehepartner/Expartner</MenuItem>
          <MenuItem value={"Lebenspartner"}>Sie ist mein Lebenspartner/Expartner</MenuItem>
          <MenuItem value={"Elternteil"}>Sie ist mein Vater/meine Mutter</MenuItem>
        </ValidatorSelectField>
      </Grid>
      <NumberFieldConfigured caseData={product} fieldPath={path + ".alimony"} fieldType={"money"} numberType={"float"} required />

      <Grid item xs={12}>
        <ValidatorSelectField
          label={"Hat die Person eigene Einnahmen"}
          name={path + ".hasIncome"}
          validators={[requiredValidator("Bitte geben Sie an ob diese Person Einnahmen hat")]}
          helperText={"z.B. Ausbildungsvergütung oder Unterhalt durch den anderen Elternteil"}
          MenuProps={{ PaperProps: { style: { maxHeight: 200 } } }}
        >
          <MenuItem value={"yes"}>Ja</MenuItem>
          <MenuItem value={"no"}>Nein</MenuItem>
        </ValidatorSelectField>
      </Grid>
      {formValue(values, path + ".hasIncome") === "yes" && (
        <>
          <NumberFieldConfigured caseData={product} fieldPath={path + ".income"} numberType={"float"} fieldType={"money"} required />
        </>
      )}
    </>
  );
}
